import {
    pxToRem,
    navigationListClassName,
    labelClassName,
    buttonClassName,
    pxArrayToRem,
    flexClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import {
    accordionTitleSlotClassNames,
    accordionTitleClassName,
    accordionContentClassName,
    accordionClassName,
} from '@fluentui/react-northstar';

export const SubFooterMobileStyle: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18, 32, 18]),
    [`& > .${accordionClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
        borderBottom: `${pxToRem(1)} solid ${
            theme.siteVariables.colorScheme.default?.foreground
        }`,
        [`& .${accordionTitleClassName}`]: {
            paddingTop: pxToRem(13),
            borderTop: `${pxToRem(1)} solid ${
                theme.siteVariables.colorScheme.default?.foreground
            }`,
        },
        [`& .${accordionTitleSlotClassNames.contentWrapper} > div:nth-child(2)`]:
            {
                color: theme.siteVariables.colorScheme.default?.bodyColor,
                fontSize: pxToRem(16),
                lineHeight: '100%',
                height: pxToRem(16),
                marginBottom: pxToRem(12),
            },
        [`& div.${accordionContentClassName}`]: {
            marginBottom: pxToRem(8),
        },
        [`& .${navigationListClassName} .${labelClassName}`]: {
            fontSize: pxToRem(14),
            lineHeight: '125%',
            height: pxToRem(18),
            color: theme.siteVariables.colorScheme.default?.foreground,
        },
        [`& div.${accordionTitleSlotClassNames.contentWrapper}  svg`]: {
            fill: theme.siteVariables.colorScheme.default?.foreground,
        },
        [`& .${navigationListClassName} > .${buttonClassName} >.${labelClassName}`]:
            {
                color: theme.siteVariables.colorScheme.default?.foreground,
            },
        [`& .${accordionTitleSlotClassNames.contentWrapper}  svg`]: {
            marginTop: `-${pxToRem(2)}`,
            marginLeft: pxToRem(2),
        },
    },
});
export const SubFooterDesktopStyle: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(6, ${pxToRem(280)})`,
    gridAutoRows: `minmax(${pxToRem(292)}, auto)`,
    columnGap: pxToRem(28),
    marginTop: pxToRem(109),
    padding: pxArrayToRem([0, 50, 0, 50]),
    flexWrap: 'wrap',
    [`& .${navigationListClassName}`]: {
        marginBottom: pxToRem(109),
    },
    [`& .${navigationListClassName} > .${flexClassName} .${buttonClassName}`]: {
        textAlign: 'left',
    },
    [`& .${navigationListClassName} > .${flexClassName} .${labelClassName}`]: {
        overflow: 'visible',
        color: theme.siteVariables.colorScheme.default?.foregroundHover,
        lineHeight: theme.siteVariables.lineHeightSmall,
    },
});
